import {Component, OnInit} from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-flash-upload',
  templateUrl: './flash-upload.component.html',
  styleUrls: ['./flash-upload.component.css']
})
export class FlashUploadComponent implements OnInit {

  constructor(private router: Router, private _rest: RestapiService) {
  }

  fullYear: number = new Date().getFullYear();
  yearArr = [];
  compObj: any;
  compData: any;
  companyId: any;
  company: any;
  respObject: any;
  companyName = '';
  selectMonth = 'January';
  forTheMonth = 0;
  forTheMonthPrevYr = 0;
  fileYear: any;
  uptoMonth = 0;
  uptoMonthPrevYr = 0;
  saveResp: any;
  fileYearErr = '';
  selectMonthErr = '';
  forTheMonthErr = '';
  forTheMonthPrevYrErr = '';
  uptoMonthErr = '';
  uptoMonthPrevYrErr = '';
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  isLock = false;

  ngOnInit() {
    for (var i = this.fullYear - 4; i <= this.fullYear; i++) {
      this.yearArr.push(i);
    }
    this.fileYear = this.fullYear;
    // this.selectMonth = this.months[new Date().getMonth()-1];
    this.selectMonth = this.months[(new Date().getMonth()-1 + 12)%12];
    if (this.selectMonth == 'December'){

      this.fileYear = this.fullYear - 1;

    }else{

      this.fileYear = this.fullYear;

    }

    console.log(this.selectMonth)
    const cRData = {};
    this.companyId = localStorage.getItem('companyId');

    this._rest.companyList(cRData).subscribe((res) => {
      this.compObj = res;
      this.compData = this.compObj.details;

      for (let i = 0; i < this.compData.length; i++) {
        if (this.compData[i].companyId == this.companyId) {
          this.companyName = this.compData[i].companyName;
          break;
        }
      }

    });

    /* =================== Added By Santanu ====================== */
    const today = new Date();
    this.isLock = today.getDate() > 7;
  }

  chngCompId() {
    this.companyId = this.company;
  }

  uploadFile() {
    if (this.isLock) {
      alert('Entry Lock');
    } else {
      let err = 0;
      if (this.selectMonth == '') {
        err++;
        this.selectMonthErr = 'Please select month.';
      } else {
        this.selectMonthErr = '';
      }
      if (this.fileYear == '') {
        err++;
        this.fileYearErr = 'Please select year.';
      } else {
        this.fileYearErr = '';
      }
      if (err == 0) {
        const uploadData = {
          'companyId': this.companyId,
          'month': this.selectMonth,
          'monthly': this.selectMonth,
          'year': this.fileYear,
          'forMonth': this.forTheMonth,
          'forMonthPrev': this.forTheMonthPrevYr,
          'uptoMonth': this.uptoMonth,
          'uptoMonthPrev': this.uptoMonthPrevYr,
          'createdBy': localStorage.getItem('userId'),
          'userId': localStorage.getItem('userId'),
          'templateType': 'Segment',
          'quarterly': '',
          'ignoreData': 0
        };
        this._rest.checkFileConfig(uploadData).subscribe((res) => {
          this.respObject = res;
          if (this.respObject.error == 0) {
            this._rest.flashUpload(uploadData).subscribe((res) => {
              this.saveResp = res;
              if (this.saveResp.error == 0) {
                this.fileYear = this.fullYear;
                this.selectMonth = this.months[new Date().getMonth()];
                this.forTheMonth = 0;
                this.forTheMonthPrevYr = 0;
                this.uptoMonth = 0;
                this.uptoMonthPrevYr = 0;
                alert('Flash data has been added successfully.');
              } else {
                if (this.saveResp.errorMessage == 'Some error occurred' || this.saveResp.errorMessage == 'Insertion Error' || this.saveResp.errorMessage == 'Selection Error'||this.saveResp.errorMessage == 'Required data missing'){
                    
                  alert(this.saveResp.errorMessage);
                }else{

                
                  if(confirm(this.saveResp.errorMessage + '\nDo you want to upload ignoring the message?')){
                    // alert(res.errorMessage);
                    const uploadData = {
                      'companyId': this.companyId,
                      'month': this.selectMonth,
                      'monthly': this.selectMonth,
                      'year': this.fileYear,
                      'forMonth': this.forTheMonth,
                      'forMonthPrev': this.forTheMonthPrevYr,
                      'uptoMonth': this.uptoMonth,
                      'uptoMonthPrev': this.uptoMonthPrevYr,
                      'createdBy': localStorage.getItem('userId'),
                      'userId': localStorage.getItem('userId'),
                      'templateType': 'Segment',
                      'quarterly': '',
                      'ignoreData': 1
                    };
            
                    this._rest.flashUpload(uploadData).subscribe((res) => {
                      this.saveResp = res;
                      if (this.saveResp.error == 0) {
                        this.fileYear = this.fullYear;
                        this.selectMonth = this.months[new Date().getMonth()];
                        this.forTheMonth = 0;
                        this.forTheMonthPrevYr = 0;
                        this.uptoMonth = 0;
                        this.uptoMonthPrevYr = 0;
                        alert('Flash data has been added successfully.');
                      } 
                    });
                  }
                }
              }
            });
          } else {
            alert(this.respObject.errorMessage);
          }
        });
      }
    }
  }

}

